import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SignupView from '../views/SignupView.vue'
import ConfirmView from '../views/ConfirmView.vue'
import LoginView from '../views/LoginView.vue'
import UserSettingView from '../views/UserSettingView.vue'
import PlayListSettingView from '../views/PlaylistSettingView.vue'
import FavoriteEventsView from '../views/FavoriteEventsView.vue'
import ReservationsView from '../views/ReservationsView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import SetNewPasswordView from '../views/SetNewPasswordView.vue'
import CheckEmailView from '../views/CheckEmailView.vue'
import Thank from '../components/Thank.vue'
import Error from '../components/Error.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/list',
    redirect: '/'
  },
  {
    path: '/event/:id',
    component: HomeView // или любой другой, который у тебя уже открыт
  },
  {
    path: '/map',
    name: 'map',
    component: HomeView
  },
  {
    path: '/map/event/:id',
    component: HomeView // или любой другой, который у тебя уже открыт
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: HomeView
  },
  {
    path: '/calendar/event/:id',
    component: HomeView // или любой другой, который у тебя уже открыт
  },
  {
    path: '/events',
    name: 'events',
    component: HomeView
  },
  {
    path: '/map/events',
    component: HomeView
  },
  {
    path: '/calendar/events',
    component: HomeView
  },
  {
    path: '/signup',
    name: 'signup',
    component: SignupView
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: ConfirmView
  },
  {
    path: '/confirm/:user_id/:code',
    name: 'confirm2',
    component: ConfirmView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/usersetting',
    name: 'usersetting',
    component: UserSettingView
  },
  {
    path: '/playlistsetting',
    name: 'playlistsetting',
    component: PlayListSettingView
  },
  {
    path: '/favoriteevents',
    name: 'favoriteevents',
    component: FavoriteEventsView
  },
  {
    path: '/thank',
    name: 'thank',
    component: Thank
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPasswordView
  },
  {
    path: '/check-email',
    name: 'check-email',
    component: CheckEmailView
  },
  {
    path: '/confirm_recovery_password/:code',
    name: 'confirm_recovery_password',
    component: SetNewPasswordView
  },
  {
    path: '/reservations',
    name: 'reservations',
    component: ReservationsView
  },
  {
    path: '/:page/:subpage*', // захватываем всё после /page/
    name: 'main-dynamic',
    component: HomeView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
